module.exports = __webpack_public_path__ + "static/img/1.c3606e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/zh/1.png
// module id = KoyT
// module chunks = 0